import React, {useState, useEffect, Fragment} from 'react'
import { Block } from '../../styles/commons'
import RefreshData from '../RefreshData/RefreshData'
import Portal from '../../stacks/portal/PortalAWS'
import {useErrorToast} from '../../hooks/useErrorToast';
import MessageList from './MessageList'

const PortalRecentMessageCenter = props => {
  const {setErrorMsg, errorToast} = useErrorToast('');
  const [messages, setMessages] = useState([])
  const [loading, setLoading] = useState(false)

  async function getRecentMessages() {
    try {
      const api = Portal.getInstance()
      setLoading(true)
      if (props.sof) {
        const mess = await api.retrieveRecentMessagesAsSOF()
        setMessages(mess)
      } else {
        const mess = await api.retrieveRecentMessages()
        setMessages(mess)
      }
      setLoading(false)
    }
    catch (err) {
      console.error(`getMessages ${err.status} ${err.message} ${err.stack}`)
      setErrorMsg(err.message)
      setLoading(false)
    }
  }

  useEffect(() => {
    getRecentMessages()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function refresh() {
    getRecentMessages()
  }

  return (
    <Fragment>
      <Block>
        <p/>
        <RefreshData style={{textAlign: 'right'}} loading={loading} onClick={refresh}/>
        <MessageList {...props} messages={messages}/>
      </Block>
      {errorToast}
    </Fragment>
  )
}

export default PortalRecentMessageCenter